import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { AccountsService } from "../api";

interface AccountsListState {
  items: unknown[];
  page: number;
  pageCount: number;
  limit: number;
  searchKeyword: string;
  contractStartDateSort: "none" | "asc" | "desc";
  contractEndDateSort: "none" | "asc" | "desc";
  corporateNameFilter: string;
  storeNameFilter: string;
  registrationRouteFilter: string;
  planTypesFilter: string;
  isActiveFilter: string;
}

interface RootState {
  accountsList: AccountsListState;
}

interface ThunkAPI {
  getState: () => RootState;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  dispatch: (value: unknown) => unknown;
}

const fetchAccounts = createAsyncThunk(
  "fetchAccounts",
  async (_: void, thunkAPI: ThunkAPI) => {
    const { accountsList } = thunkAPI.getState();
    const {
      page,
      limit,
      searchKeyword,
      contractStartDateSort,
      contractEndDateSort,
      corporateNameFilter,
      storeNameFilter,
      registrationRouteFilter,
      planTypesFilter,
      isActiveFilter,
    } = accountsList;

    const request = {
      page,
      limit,
      searchKeyword,
      contractStartDateSort,
      contractEndDateSort,
      corporateNameFilter,
      storeNameFilter,
      registrationRouteFilter,
      planTypesFilter,
      isActiveFilter,
    };
    console.log("アカウント一覧取得API リクエスト:", request);

    const res = await AccountsService.accountsList(request);
    console.log("アカウント一覧取得API レスポンス:", res);

    const { results, page_count } = res;
    thunkAPI.dispatch(accountsListActions.setItems(results));
    thunkAPI.dispatch(accountsListActions.setPageCount(page_count));
  },
);

const doSearchKeywordAndFetch = createAsyncThunk(
  "doSearchKeywordAndFetch",
  async (_: void, thunkAPI: ThunkAPI) => {
    thunkAPI.dispatch(accountsListActions.setPage(1));
    thunkAPI.dispatch(accountsListActions.fetchAccounts());
  },
);

const setPageAndFetch = createAsyncThunk(
  "setPageAndFetch",
  async (page: number, thunkAPI: ThunkAPI) => {
    thunkAPI.dispatch(accountsListActions.setPage(page));
    thunkAPI.dispatch(accountsListActions.fetchAccounts());
  },
);

const switchSortContractStartDate = createAsyncThunk(
  "switchSortContractStartDate",
  async (_: void, thunkAPI: ThunkAPI) => {
    const { accountsList } = thunkAPI.getState();
    const { contractStartDateSort } = accountsList;
    let newSort;
    if (contractStartDateSort === "none") newSort = "asc";
    else if (contractStartDateSort === "asc") newSort = "desc";
    else newSort = "none";
    thunkAPI.dispatch(accountsListActions.setContractStartDateSort(newSort));
    thunkAPI.dispatch(accountsListActions.fetchAccounts());
  },
);

const switchSortContractEndDate = createAsyncThunk(
  "switchSortContractEndDate",
  async (_: void, thunkAPI: ThunkAPI) => {
    const { accountsList } = thunkAPI.getState();
    const { contractEndDateSort } = accountsList;
    let newSort;
    if (contractEndDateSort === "none") newSort = "asc";
    else if (contractEndDateSort === "asc") newSort = "desc";
    else newSort = "none";
    thunkAPI.dispatch(accountsListActions.setContractEndDateSort(newSort));
    thunkAPI.dispatch(accountsListActions.fetchAccounts());
  },
);

const initialState: AccountsListState = {
  items: [],
  page: 1,
  pageCount: 1,
  limit: 20,
  searchKeyword: "",
  contractStartDateSort: "none" as "none" | "asc" | "desc",
  contractEndDateSort: "none" as "none" | "asc" | "desc",
  corporateNameFilter: "",
  storeNameFilter: "",
  registrationRouteFilter: "",
  planTypesFilter: "",
  isActiveFilter: "",
};

const accountsListSlice = createSlice({
  name: "accountsList",
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<unknown[]>) => {
      state.items = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPageCount: (state, action: PayloadAction<number>) => {
      state.pageCount = action.payload;
    },
    setSearchKeyword: (state, action: PayloadAction<string>) => {
      state.searchKeyword = action.payload;
    },
    setContractStartDateSort: (
      state,
      action: PayloadAction<"none" | "asc" | "desc">,
    ) => {
      state.contractStartDateSort = action.payload;
    },
    setContractEndDateSort: (
      state,
      action: PayloadAction<"none" | "asc" | "desc">,
    ) => {
      state.contractEndDateSort = action.payload;
    },
    setCorporateNameFilter: (state, action: PayloadAction<string>) => {
      state.corporateNameFilter = action.payload;
    },
    setStoreNameFilter: (state, action: PayloadAction<string>) => {
      state.storeNameFilter = action.payload;
    },
    setRegistrationRouteFilter: (state, action: PayloadAction<string>) => {
      state.registrationRouteFilter = action.payload;
    },
    setPlanTypesFilter: (state, action: PayloadAction<string>) => {
      state.planTypesFilter = action.payload;
    },
    setIsActiveFilter: (state, action: PayloadAction<string>) => {
      state.isActiveFilter = action.payload;
    },
    setInitState: () => {
      return initialState;
    },
  },
});

const accountsListActions = {
  ...accountsListSlice.actions,
  fetchAccounts,
  setPageAndFetch,
  doSearchKeywordAndFetch,
  switchSortContractStartDate,
  switchSortContractEndDate,
};
export { accountsListActions };
export default accountsListSlice.reducer;
